// // src/components/landing/LandingHeader.tsx
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, LogIn, Phone, Mail, ShoppingCart } from "lucide-react";
// import { useCart } from "../../context/CartContext";

// // This assumes your CartContext exposes an `items` array (or an
// // `itemCount` number) on its context value. If your real CartContext
// // uses different field names, adjust the `cartCount` line below —
// // nothing else in this file depends on the rest of the cart shape.

// export function TopBar() {
//   return (
//     <div className="hidden bg-orange-500 text-white sm:block">
//       <div className="mx-auto flex max-w-7xl items-center justify-between px-8 py-2 text-base">
//         <div className="flex items-center gap-5 text-white">
//           <span className="flex items-center gap-1.5">
//             <Phone className="h-3.5 w-3.5" /> Toll Free: 1800-233-4567
//           </span>
//           <span className="flex items-center gap-1.5">
//             <Mail className="h-3.5 w-3.5" /> hello@adroj.com
//           </span>
//         </div>
//         <div className="flex items-center gap-4">
//           <Link to="/cart" className="rounded-full border border-white/25 px-3 py-1 font-medium text-white transition-colors hover:bg-white/10">
//             View cart
//           </Link>
//           <a href="#for-owners" className="font-medium text-white/70 hover:text-white">
//             List your space
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }

// export function LandingHeader() {
//   const [open, setOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const cart = useCart();
//   const cartCount = Array.isArray((cart as any)?.items)
//     ? (cart as any).items.length
//     : (cart as any)?.itemCount ?? 0;

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 8);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   const navLinks = [
//     { label: "Browse spaces", href: "#listings" },
//     { label: "How it works", href: "#how-it-works" },
//     { label: "For owners", href: "#for-owners" },
//   ];

//   return (
//     <>
//       <TopBar />
//       <header
//         className={`sticky top-0 z-40 bg-white transition-shadow duration-300 ${
//           scrolled ? "shadow-[0_1px_0_0_rgba(15,23,42,0.08)]" : ""
//         }`}
//       >
//         <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
//           <Link to="/" className="flex items-center gap-2">
//             <img src="/adrojlogo.png" alt="Adroj" className="h-12 w-auto" />
//           </Link>

//           <nav className="hidden items-center gap-8 md:flex">
//             {navLinks.map((l) => (
//               <a
//                 key={l.label}
//                 href={l.href}
//                 className="text-base font-medium text-slate-600 transition-colors hover:text-[#0F172A]"
//               >
//                 {l.label}
//               </a>
//             ))}
//           </nav>

//           <div className="hidden items-center gap-3 md:flex">
//             <Link
//               to="/cart"
//               className="relative flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
//             >
//               <ShoppingCart className="h-4 w-4" /> Cart
//               {cartCount > 0 && (
//                 <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#EB4A2D] text-[10px] font-bold text-white">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>
//             <Link
//               to="/login"
//               className="flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
//             >
//               <LogIn className="h-4 w-4" /> Login
//             </Link>
//             <a
//               href="#listings"
//               className="rounded-full bg-[#EB4A2D] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-transform hover:scale-[1.03]"
//             >
//               Browse spaces
//             </a>
//           </div>

//           <button
//             className="rounded-lg p-2 text-slate-700 md:hidden"
//             onClick={() => setOpen((o) => !o)}
//             aria-label="Toggle menu"
//           >
//             {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
//           </button>
//         </div>

//         {open && (
//           <div className="border-t border-slate-100 bg-white px-5 py-4 md:hidden">
//             <div className="flex flex-col gap-4">
//               {navLinks.map((l) => (
//                 <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-slate-700">
//                   {l.label}
//                 </a>
//               ))}
//               <Link to="/cart" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
//                 <ShoppingCart className="h-4 w-4" /> Cart {cartCount > 0 ? `(${cartCount})` : ""}
//               </Link>
//               <Link to="/login" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
//                 <LogIn className="h-4 w-4" /> Login
//               </Link>
//               <a
//                 href="#listings"
//                 onClick={() => setOpen(false)}
//                 className="mt-1 rounded-full bg-[#EB4A2D] px-4 py-2.5 text-center text-sm font-semibold text-white"
//               >
//                 Browse spaces
//               </a>
//             </div>
//           </div>
//         )}
//       </header>
//     </>
//   );
// }


//========================




// src/components/landing/LandingHeader.tsx
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, LogIn, Phone, Mail, ShoppingCart } from "lucide-react";
// import { useCart } from "../../context/CartContext";
// import { getCartCount } from "../../utils/cartItem";

// // This assumes your CartContext exposes an `items` array (or an
// // `itemCount` number) on its context value. getCartCount() normalizes
// // whatever shape `items` actually holds so this badge always matches
// // what ViewCartPage renders.

// export function TopBar() {
//   return (
//     <div className="hidden bg-orange-500 text-white sm:block">
//       <div className="mx-auto flex max-w-7xl items-center justify-between px-8 py-2 text-base">
//         <div className="flex items-center gap-5 text-white">
//           <span className="flex items-center gap-1.5">
//             <Phone className="h-3.5 w-3.5" /> Toll Free: 1800-233-4567
//           </span>
//           <span className="flex items-center gap-1.5">
//             <Mail className="h-3.5 w-3.5" /> hello@adroj.com
//           </span>
//         </div>
//         <div className="flex items-center gap-4">
//           <Link to="/cart" className="rounded-full border border-white/25 px-3 py-1 font-medium text-white transition-colors hover:bg-white/10">
//             View cart
//           </Link>
//           <a href="#for-owners" className="font-medium text-white/70 hover:text-white">
//             List your space
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }

// export function LandingHeader() {
//   const [open, setOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const cart = useCart();
//   const cartCount = getCartCount(cart);

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 8);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   const navLinks = [
//     { label: "Browse spaces", href: "/listings" },
//     { label: "How it works", href: "#how-it-works" },
//     { label: "For owners", href: "#for-owners" },
//   ];

//   return (
//     <>
//       <TopBar />
//       <header
//         className={`sticky top-0 z-40 bg-white transition-shadow duration-300 ${
//           scrolled ? "shadow-[0_1px_0_0_rgba(15,23,42,0.08)]" : ""
//         }`}
//       >
//         <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
//           <Link to="/" className="flex items-center gap-2">
//             <img src="/adrojlogo.png" alt="Adroj" className="h-12 w-auto" />
//           </Link>

//           <nav className="hidden items-center gap-8 md:flex">
//             {navLinks.map((l) => (
//               <a
//                 key={l.label}
//                 href={l.href}
//                 className="text-base font-medium text-slate-600 transition-colors hover:text-[#0F172A]"
//               >
//                 {l.label}
//               </a>
//             ))}
//           </nav>

//           <div className="hidden items-center gap-3 md:flex">
//             <Link
//               to="/cart"
//               className="relative flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
//             >
//               <ShoppingCart className="h-4 w-4" /> Cart
//               {cartCount > 0 && (
//                 <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#EB4A2D] text-[10px] font-bold text-white">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>
//             <Link
//               to="/login"
//               className="flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
//             >
//               <LogIn className="h-4 w-4" /> Login
//             </Link>
//             <a
//               href="/listings"
//               className="rounded-full bg-[#EB4A2D] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-transform hover:scale-[1.03]"
//             >
//               Browse spaces
//             </a>
//           </div>

//           <button
//             className="rounded-lg p-2 text-slate-700 md:hidden"
//             onClick={() => setOpen((o) => !o)}
//             aria-label="Toggle menu"
//           >
//             {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
//           </button>
//         </div>

//         {open && (
//           <div className="border-t border-slate-100 bg-white px-5 py-4 md:hidden">
//             <div className="flex flex-col gap-4">
//               {navLinks.map((l) => (
//                 <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-slate-700">
//                   {l.label}
//                 </a>
//               ))}
//               <Link to="/cart" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
//                 <ShoppingCart className="h-4 w-4" /> Cart {cartCount > 0 ? `(${cartCount})` : ""}
//               </Link>
//               <Link to="/login" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
//                 <LogIn className="h-4 w-4" /> Login
//               </Link>
//               <a
//                 href="/listings"
//                 onClick={() => setOpen(false)}
//                 className="mt-1 rounded-full bg-[#EB4A2D] px-4 py-2.5 text-center text-sm font-semibold text-white"
//               >
//                 Browse spaces
//               </a>
//             </div>
//           </div>
//         )}
//       </header>
//     </>
//   );
// }





//===========================================





// src/components/landing/LandingHeader.tsx
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, LogIn, Phone, Mail, ShoppingCart } from "lucide-react";
// import { useCart } from "../../context/CartContext";

// export function TopBar() {
//   return (
//     <div className="hidden bg-orange-500 text-white sm:block">
//       <div className="mx-auto flex max-w-7xl items-center justify-between px-8 py-2 text-base">
//         <div className="flex items-center gap-5 text-white">
//           <span className="flex items-center gap-1.5">
//             <Phone className="h-3.5 w-3.5" /> Toll Free: 1800-233-4567
//           </span>
//           <span className="flex items-center gap-1.5">
//             <Mail className="h-3.5 w-3.5" /> hello@adroj.com
//           </span>
//         </div>
//         <div className="flex items-center gap-4">
//           <Link to="/cart" className="rounded-full border border-white/25 px-3 py-1 font-medium text-white transition-colors hover:bg-white/10">
//             View cart
//           </Link>
//           <a href="#for-owners" className="font-medium text-white/70 hover:text-white">
//             List your space
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }

// export function LandingHeader() {
//   const [open, setOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const cart = useCart();
//   const cartCount = cart.itemCount;

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 8);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   const navLinks = [
//     { label: "Browse spaces", href: "#listings" },
//     { label: "How it works", href: "#how-it-works" },
//     { label: "For owners", href: "#for-owners" },
//   ];

//   return (
//     <>
//       <TopBar />
//       <header
//         className={`sticky top-0 z-40 bg-white transition-shadow duration-300 ${
//           scrolled ? "shadow-[0_1px_0_0_rgba(15,23,42,0.08)]" : ""
//         }`}
//       >
//         <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
//           <Link to="/" className="flex items-center gap-2">
//             <img src="/adrojlogo.png" alt="Adroj" className="h-12 w-auto" />
//           </Link>

//           <nav className="hidden items-center gap-8 md:flex">
//             {navLinks.map((l) => (
//               <a
//                 key={l.label}
//                 href={l.href}
//                 className="text-base font-medium text-slate-600 transition-colors hover:text-[#0F172A]"
//               >
//                 {l.label}
//               </a>
//             ))}
//           </nav>

//           <div className="hidden items-center gap-3 md:flex">
//             <Link
//               to="/cart"
//               className="relative flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
//             >
//               <ShoppingCart className="h-4 w-4" /> Cart
//               {cartCount > 0 && (
//                 <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#EB4A2D] text-[10px] font-bold text-white">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>
//             <Link
//               to="/login"
//               className="flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
//             >
//               <LogIn className="h-4 w-4" /> Login
//             </Link>
//             <a
//               href="#listings"
//               className="rounded-full bg-[#EB4A2D] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-transform hover:scale-[1.03]"
//             >
//               Browse spaces
//             </a>
//           </div>

//           <button
//             className="rounded-lg p-2 text-slate-700 md:hidden"
//             onClick={() => setOpen((o) => !o)}
//             aria-label="Toggle menu"
//           >
//             {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
//           </button>
//         </div>

//         {open && (
//           <div className="border-t border-slate-100 bg-white px-5 py-4 md:hidden">
//             <div className="flex flex-col gap-4">
//               {navLinks.map((l) => (
//                 <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-slate-700">
//                   {l.label}
//                 </a>
//               ))}
//               <Link to="/cart" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
//                 <ShoppingCart className="h-4 w-4" /> Cart {cartCount > 0 ? `(${cartCount})` : ""}
//               </Link>
//               <Link to="/login" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
//                 <LogIn className="h-4 w-4" /> Login
//               </Link>
//               <a
//                 href="#listings"
//                 onClick={() => setOpen(false)}
//                 className="mt-1 rounded-full bg-[#EB4A2D] px-4 py-2.5 text-center text-sm font-semibold text-white"
//               >
//                 Browse spaces
//               </a>
//             </div>
//           </div>
//         )}
//       </header>
//     </>
//   );
// }







//=============================================





// src/components/landing/LandingHeader.tsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogIn, Phone, Mail, ShoppingCart, MessageSquare } from "lucide-react";
import { useCart } from "../../context/CartContext";

export function TopBar() {
  return (
    <div className="hidden bg-orange-500 text-white sm:block">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-8 py-2 text-base">
        <div className="flex items-center gap-5 text-white">
          <span className="flex items-center gap-1.5">
            <Phone className="h-3.5 w-3.5" /> Phone No: +91 7599596559
          </span>
          <span className="flex items-center gap-1.5">
            <Mail className="h-3.5 w-3.5" /> contact@adroj.com
          </span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/cart" className="rounded-full border border-white/25 px-3 py-1 font-medium text-white transition-colors hover:bg-white/10">
            View cart
          </Link>
          <a href="#for-owners" className="font-medium text-white/70 hover:text-white">
            List your space
          </a>
        </div>
      </div>
    </div>
  );
}

export function LandingHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const cart = useCart();
  const cartCount = cart.itemCount;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Browse spaces", href: "#listings" },
    { label: "How it works", href: "#how-it-works" },
    { label: "For owners", href: "#for-owners" },
  ];

  return (
    <>
      <TopBar />
      <header
        className={`sticky top-0 z-40 bg-white transition-shadow duration-300 ${
          scrolled ? "shadow-[0_1px_0_0_rgba(15,23,42,0.08)]" : ""
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
          <Link to="/" className="flex items-center gap-2">
            <img src="/adrojlogo.png" alt="Adroj" className="h-12 w-auto" />
          </Link>

          <nav className="hidden items-center gap-8 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-base font-medium text-slate-600 transition-colors hover:text-[#0F172A]"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/cart"
              className="relative flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
            >
              <ShoppingCart className="h-4 w-4" /> Cart
              {cartCount > 0 && (
                <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#EB4A2D] text-[10px] font-bold text-white">
                  {cartCount}
                </span>
              )}
            </Link>
            <a
              href="#discuss-campaign"
              className="flex items-center gap-1.5 rounded-full border border-[#EB4A2D]/30 px-4 py-2 text-sm font-semibold text-[#EB4A2D] transition-colors hover:bg-[#EB4A2D]/5"
            >
              <MessageSquare className="h-4 w-4" /> Discuss Your Campaign
            </a>
            <Link
              to="/login"
              className="flex items-center gap-1.5 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-300 hover:bg-slate-50"
            >
              <LogIn className="h-4 w-4" /> Login
            </Link>
            <a
              href="#listings"
              className="rounded-full bg-[#EB4A2D] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-transform hover:scale-[1.03]"
            >
              Browse spaces
            </a>
          </div>

          <button
            className="rounded-lg p-2 text-slate-700 md:hidden"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div className="border-t border-slate-100 bg-white px-5 py-4 md:hidden">
            <div className="flex flex-col gap-4">
              {navLinks.map((l) => (
                <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-slate-700">
                  {l.label}
                </a>
              ))}
              <Link to="/cart" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
                <ShoppingCart className="h-4 w-4" /> Cart {cartCount > 0 ? `(${cartCount})` : ""}
              </Link>
              <a href="#discuss-campaign" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-[#EB4A2D]">
                <MessageSquare className="h-4 w-4" /> Discuss Your Campaign
              </a>
              <Link to="/login" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-sm font-semibold text-slate-700">
                <LogIn className="h-4 w-4" /> Login
              </Link>
              <a
                href="#listings"
                onClick={() => setOpen(false)}
                className="mt-1 rounded-full bg-[#EB4A2D] px-4 py-2.5 text-center text-sm font-semibold text-white"
              >
                Browse spaces
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}